import React, { Component } from 'react';
import WatchlistService from '../../../service/WatchlistService';
import ServiceContainer from '../../../config/ServiceContainer';
import { ServiceNames } from '../../../constant/ServiceNames';
import { WatchlistNewsDomains } from '../../../domain/watchlist/WatchlistNewsDomains';
import CustomLoading from '../../custom/CustomLoading';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import WatchlistNewsPanelComponent from '../detail/WatchlistNewsPanelComponent';
import Icon from '../../../icons/Icon';
import moment from 'moment';
import { store } from '../../../redux/store';
import { initialPagePath } from '../../../redux/reducers/PageReducer';
import ComponentName from '../../../constant/ComponentName';
import FolderService from '../../../service/FolderService';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../custom/FormicaSearchSelectBox';
import LanguageUtil from '../../../util/LanguageUtil';
import WatchlistNewsRegionResolver from '../../../util/WatchlistNewsRegionResolver';

class WatchlistNewsComponent extends Component<Props, State> {
  public state = new State(store.getState().page.language);

  private watchlistService: WatchlistService = ServiceContainer.getInstance().get(ServiceNames.WATCHLIST);
  private newsRequestId: number = 0;

  render() {
    const { loading, newsResponse, name, region, selectedIcon } = this.state;
    if (loading || name == undefined) {
      return <CustomLoading />;
    }
    if (newsResponse == undefined) {
      return (
        <div className={'h-full w-full px-5'}>
          <div className={'w-full h-full flex flex-col items-center justify-center bg-main-gray border rounded-[8px]'}>
            <div className={'w-1/3 flex flex-col items-center justify-center gap-y-1'}>
              <img src={'/icons/empty.svg'} alt='empty' className={'w-[120px] h-[120px]'} />
              <span className={'text-black text-[16px]'}>
                {LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.noResult', defaultMessage: 'There is no results about news' })}
              </span>
              {LanguageUtil.get({
                id: 'pages.watchlist.watchlistDetail.news.noNews',
                defaultMessage: 'No news was found on the internet regarding the name you searched!',
              })}
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className='max-h-[calc(100vh-16rem)] py-5 w-full overflow-y-scroll px-5'>
        <div className={'flex justify-between border rounded-[8px] p-4 mb-4 items-center'}>
          <div className={'flex items-center gap-x-3'}>
            <span key={'icon'}>{this.getImage()}</span>
            <div className={'flex flex-col'}>
              <div className={'flex items-center gap-x-2'}>
                <span className={'text-f-black-2 text-[20px] font-medium'}>
                  {newsResponse.name ||
                    LanguageUtil.get({
                      id: 'pages.watchlist.watchlistDetail.news.nameNotFound',
                      defaultMessage: 'Name Not Found',
                    })}
                </span>
                <div className={'flex gap-x-2 h-auto'}>
                  {newsResponse.entityTypes?.map((type, index) => {
                    return (
                      <span
                        key={index}
                        className={`flex text-xs shrink-0 2xl:text-md h-full justify-center items-center px-[8px] py-[3px] rounded-[50px] bg-[#DBFFEA] text-[#027A48]`}
                      >
                        {type}
                      </span>
                    );
                  })}
                  {newsResponse.websiteUrl && (
                    <span
                      className={'flex items-center text-[12px] underline text-normal text-[#458EF7] cursor-pointer'}
                      onClick={() => window.open(newsResponse?.websiteUrl, '_blank')}
                    >
                      {LanguageUtil.get({ id: 'common.label.website', defaultMessage: 'Website' })}
                    </span>
                  )}
                </div>
              </div>
              <span className={'text-[#607080] text-[13px]'}>
                {newsResponse.hint ||
                  LanguageUtil.get({
                    id: 'pages.watchlist.watchlistDetail.news.hintNotFound',
                    defaultMessage: 'Hint Not Found',
                  })}
              </span>
            </div>
          </div>
          <div className={'flex'}>
            <FormicaSearchSelectBox
              rounded={true}
              onChange={this.onChangeRegion}
              value={region}
              customSize='medium'
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.filterType', defaultMessage: 'Filter Type' })}
              options={this.getOptions()}
              iconNode={selectedIcon}
            />
          </div>
        </div>
        <div className={'w-full flex gap-x-4'}>
          {newsResponse.news != undefined && newsResponse.news.length != 0 ? (
            <div className={'w-2/3'}>
              <WatchlistNewsPanelComponent newsResponse={newsResponse} />
            </div>
          ) : (
            <div className={'w-full flex items-center justify-center border rounded-[8px]'}>
              <img src={'/icons/news_empty.svg'} alt='empty' />
            </div>
          )}
          {newsResponse.description != undefined && (
            <div className={`${newsResponse.news == undefined || newsResponse.news.length == 0 ? 'w-full' : 'w-1/3'} flex flex-col gap-y-4`}>
              <div className={'border rounded-[8px] p-4'}>
                <div className={'flex items-center gap-x-1'}>
                  <Icon icon={'kyc_wikipedia2icon'} size={24} />
                  <div className={'text-f-black-2 text-[20px]'}>{LanguageUtil.get({ id: 'common.label.wikipedia', defaultMessage: 'Website' })}</div>
                </div>
                <span className={'text-[#607080] text-[13px]'}>
                  {newsResponse.description}
                  {newsResponse?.wikipediaUrl && (
                    <span
                      className={'flex items-center text-[12px] underline text-normal text-[#458EF7] cursor-pointer w-2/3 text-justify'}
                      onClick={() => window.open(newsResponse?.wikipediaUrl, '_blank')}
                    >
                      {LanguageUtil.get({ id: 'common.label.wikipedia', defaultMessage: 'Website' })}
                    </span>
                  )}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  public async componentDidMount() {
    const { router, name: nameProp } = this.props;
    if (nameProp == undefined) {
      const page = store.getState().page;
      const initial = initialPagePath[ComponentName.WATCHLIST];
      if (page.pagePath.length == 0 || page.pagePath[0].title != initial?.title) {
        await FolderService.calculate('WITHOUT_FOLDER', ComponentName.WATCHLIST, router.location.pathname, store.getState().page);
      }
    }
    const name: string | null = nameProp ?? new URLSearchParams(router.params.id).get('name');
    this.setState({ name, date: moment().format('DD/MM/yyyy HH:mm').valueOf() }, () => this.getNewsData());
  }

  public componentDidUpdate(prevProps: Props): void {
    if (prevProps.exactMatch === this.props.exactMatch) {
      return;
    }
    void this.getNewsData();
  }

  public componentWillUnmount() {
    this.newsRequestId = this.newsRequestId + 1;
  }

  private getNewsData = async () => {
    const { region, name } = this.state;
    const requestId: number = this.newsRequestId + 1;
    this.newsRequestId = requestId;
    this.setState({ loading: true });
    if (!name) {
      return;
    }
    try {
      const response = await this.watchlistService.getNews(name, region, this.props.exactMatch);
      if (requestId !== this.newsRequestId) {
        return;
      }
      if (response) {
        this.setState({
          newsResponse: response,
          loading: false,
        });
      }
    } catch {
      if (requestId !== this.newsRequestId) {
        return;
      }
      this.setState({ loading: false });
    }
  };

  private onChangeRegion = (e: FormicaSelectBoxItem) => {
    this.setState(
      {
        region: e.value,
        selectedIcon: e.iconNode,
      },
      () => this.getNewsData(),
    );
  };

  private getImage = () => {
    const { newsResponse } = this.state;
    if (newsResponse) {
      if (newsResponse.imageUrl) {
        return (
          <img
            src={newsResponse.imageUrl}
            alt='image'
            className={'w-[72px] h-[72px] border flex justify-center items-center rounded-[8px] bg-[#EFF2FE] object-cover'}
          />
        );
      } else {
        return (
          <img
            src={'/icons/individual.svg'}
            alt='individual'
            className={'w-[72px] h-[72px] flex justify-center items-center rounded-[8px] bg-[#EFF2FE] mr-1'}
          />
        );
      }
    }
  };

  private getOptions() {
    return [
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.argentina', defaultMessage: 'Argentina (Spanish)' }),
        value: 'es-AR',
        iconNode: <img src={`/country/Argentina.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.australia', defaultMessage: 'Australia (English)' }),
        value: 'en-AU',
        iconNode: <img src={`/country/Australia.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.austria', defaultMessage: 'Austria (German)' }),
        value: 'de-AT',
        iconNode: <img src={`/country/Austria.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.belgiumDutch', defaultMessage: 'Belgium (Dutch)' }),
        value: 'nl-BE',
        iconNode: <img src={`/country/Belgium.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.belgiumFrench', defaultMessage: 'Belgium (French)' }),
        value: 'fr-BE',
        iconNode: <img src={`/country/Belgium.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.brazil', defaultMessage: 'Brazil (Portuguese)' }),
        value: 'pt-BR',
        iconNode: <img src={`/country/Brazil.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.canadaEng', defaultMessage: 'Canada (English)' }),
        value: 'en-CA',
        iconNode: <img src={`/country/Canada.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.canadaFrench', defaultMessage: 'Canada (French)' }),
        value: 'fr-CA',
        iconNode: <img src={`/country/Canada.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.chile', defaultMessage: 'Chile (Spanish)' }),
        value: 'es-CL',
        iconNode: <img src={`/country/Chile.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.denmark', defaultMessage: 'Denmark (Danish)' }),
        value: 'da-DK',
        iconNode: <img src={`/country/Denmark.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.finland', defaultMessage: 'Finland (Finnish)' }),
        value: 'fi-FI',
        iconNode: <img src={`/country/Finland.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.france', defaultMessage: 'France (French)' }),
        value: 'fr-FR',
        iconNode: <img src={`/country/France.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.germany', defaultMessage: 'Germany (German)' }),
        value: 'de-DE',
        iconNode: <img src={`/country/Germany.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.hongKong', defaultMessage: 'Hong Kong (Traditional Chinese)' }),
        value: 'zh-HK',
        iconNode: <img src={`/country/Hong Kong.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.india', defaultMessage: 'India (English)' }),
        value: 'en-IN',
        iconNode: <img src={`/country/India.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.indonesia', defaultMessage: 'Indonesia (English)' }),
        value: 'en-ID',
        iconNode: <img src={`/country/Indonesia.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.italy', defaultMessage: 'Italy (Italian)' }),
        value: 'it-IT',
        iconNode: <img src={`/country/Italy.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.japan', defaultMessage: 'Japan (Japanese)' }),
        value: 'ja-JP',
        iconNode: <img src={`/country/Japan.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.korea', defaultMessage: 'Korea (Korean)' }),
        value: 'ko-KR',
        iconNode: <img src={`/country/North Korea.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.malaysia', defaultMessage: 'Malaysia (English)' }),
        value: 'en-MY',
        iconNode: <img src={`/country/Malaysia.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.mexico', defaultMessage: 'Mexico (Spanish)' }),
        value: 'es-MX',
        iconNode: <img src={`/country/Mexico.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.netherlands', defaultMessage: 'Netherlands (Dutch)' }),
        value: 'nl-NL',
        iconNode: <img src={`/country/Netherlands.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.newZealand', defaultMessage: 'New Zealand (English)' }),
        value: 'en-NZ',
        iconNode: <img src={`/country/New Zealand.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.norway', defaultMessage: 'Norway (Norwegian)' }),
        value: 'no-NO',
        iconNode: <img src={`/country/Norway.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.china', defaultMessage: 'China Chinese' }),
        value: 'zh-CN',
        iconNode: <img src={`/country/China.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.poland', defaultMessage: 'Poland (Polish)' }),
        value: 'pl-PL',
        iconNode: <img src={`/country/Poland.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.philippines', defaultMessage: 'Philippines (English)' }),
        value: 'en-PH',
        iconNode: <img src={`/country/Philippines.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.russia', defaultMessage: 'Russia (Russian)' }),
        value: 'ru-RU',
        iconNode: <img src={`/country/Russia.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.southAfrica', defaultMessage: 'South Africa (English)' }),
        value: 'en-ZA',
        iconNode: <img src={`/country/South Africa.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.spain', defaultMessage: 'Spain (Spanish)' }),
        value: 'es-ES',
        iconNode: <img src={`/country/Spain.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.sweden', defaultMessage: 'Sweden (Swedish)' }),
        value: 'sv-SE',
        iconNode: <img src={`/country/Sweden.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.switzerlandFrench', defaultMessage: 'Switzerland (French)' }),
        value: 'fr-CH',
        iconNode: <img src={`/country/Switzerland.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.switzerlandGerman', defaultMessage: 'Switzerland (German)' }),
        value: 'de-CH',
        iconNode: <img src={`/country/Switzerland.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.taiwan', defaultMessage: 'Taiwan (Traditional Chinese)' }),
        value: 'zh-TW',
        iconNode: <img src={`/country/Taiwan.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.turkey', defaultMessage: 'Turkey (Turkish)' }),
        value: 'tr-TR',
        iconNode: <img src={`/country/Turkey.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.uk', defaultMessage: 'United Kingdom (English)' }),
        value: 'en-GB',
        iconNode: <img src={`/country/United Kingdom.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.usEng', defaultMessage: 'United States (English)' }),
        value: 'en-US',
        iconNode: <img src={`/country/United States of America.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
      {
        label: LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.countries.usSpanish', defaultMessage: 'United States (Spanish)' }),
        value: 'es-US',
        iconNode: <img src={`/country/United States of America.svg`} className={'w-[20px] h-[20px]'} alt='country' />,
      },
    ];
  }
}

interface Props extends FormicaProps {
  name?: string;
  exactMatch?: boolean;
}

class State {
  newsResponse: WatchlistNewsDomains | undefined;
  loading: boolean = true;
  date: string | undefined;
  name: string | undefined | null;
  region: string;
  selectedIcon: React.ReactNode;

  public constructor(language: string) {
    const newsRegion = WatchlistNewsRegionResolver.resolve(language);
    this.region = newsRegion.getRegion();
    this.selectedIcon = (
      <img src={`/country/${newsRegion.getCountryFileName()}.svg`} className={'w-[20px] h-[20px]'} alt='country' />
    );
  }
}

export default withFormica(WatchlistNewsComponent);
